"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var notes_1 = require("../data/notes");
exports.projectData = { notes: notes_1.noteData };
